import cx from 'classnames';
import { useHeaderContext } from '../../context/header-context';
import type { PropsWithChildren } from 'react';

export const DesktopBottomSection = ({ children }: PropsWithChildren) => {
  const {
    visual: { isTranslucent, isFluid },
    navigation: { bottomNavLinkAreaClassName },
  } = useHeaderContext();
  return (
    <div className={cx(!isTranslucent && 'osc-nav-bottom-link-area', bottomNavLinkAreaClassName)}>
      <div className={cx(isFluid ? 'container-fluid' : 'container')}>
        <div className="flex">
          <div className="flex overflow-auto" data-testid="header-links-container">
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};
